import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/auth';
import TimeSlot from './time_slot';
import DailyShiftPreviewTable from './daily_shift_preview_table';
import { createWorkingHoursCompound } from '../services/api_working_hours';
import Swal from 'sweetalert2';
import { formatTime } from '../utils/timeslots';
import PairOrgUnit from './pair_org_unit';



export function DailyShift({ selectedDay, shiftData, onShiftDeleted, onShiftAdded, creatingWWH }) {
  const { token } = useContext(AuthContext)
  const [shiftName, setShiftName] = useState('');
  const [showTimeSlot, setShowTimeSlot] = useState(true);
  const [error, setError] = useState('');
  const [shiftPreviews, setShiftPreviews] = useState(shiftData || []);
  const [isSlotAdded, setIsSlotAdded] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [showAddTimeSlotButton, setShowAddTimeSlotButton] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedOu, setSelectedOu] = useState(null);
  const [creatingDS, setCreatingDS] = useState(false);

  const handleSelectOrganizationalUnit = (ou) => {
    setSelectedOu(ou);
  };

  const resetSelectedOrganizationalUnit = () => {
    setSelectedOu(null);
  };

  const handleShiftNameChange = (e) => {
    setShiftName(e.target.value);
    setError('');
  };

  // const checkIt = (previewData, indexToExclude = null) => {
  //   const overlappingShift = shiftPreviews.some((preview, index) => {
  //     if (index === indexToExclude) return false;
  //     return (
  //       (previewData.workStartTime > preview.workStartTime && previewData.workStartTime < preview.workEndTime) ||
  //       (previewData.workEndTime > preview.workStartTime && previewData.workEndTime < preview.workEndTime) ||
  //       (previewData.workStartTime < preview.workStartTime && previewData.workEndTime > preview.workEndTime )
  //     );
  //   });
  
  //   return overlappingShift;
  // }

  // TODO: TESTARE OVERLAPPING SE FUNZIONA IN OGNI CASO, ALTRIMENTI RIPRISTINARE FUNZIONE PRECEDENTE COMMENTATA
  const checkIt = (previewData, indexToExclude = null) => {
    const newStart = previewData.workStartTime;
    const newEnd = previewData.workEndTime;

    // Non consentito: orario di inizio uguale a quello di fine
    if (newStart === newEnd) {
      return true;
    }

    return shiftPreviews.some((preview, index) => {
      if (index === indexToExclude) return false;

      const existingStart = preview.workStartTime;
      const existingEnd = preview.workEndTime;

      // Vietato se perfettamente uguali
      if (newStart === existingStart && newEnd === existingEnd) {
        return true;
      }

      // Consentito se inizia subito dopo o finisce subito prima (no overlap)
      if (newEnd <= existingStart || newStart >= existingEnd) {
        return false;
      }

      // Tutti gli altri casi sono sovrapposizioni
      return true;
    });
  };



  const handleShiftPreview = (previewData, index = null) => {
    //const insertionIndex = shiftPreviews.findIndex(preview => previewData.workStartTime < preview.workStartTime);
    
    if (checkIt(previewData, index)) {
      setError("La nuova fascia oraria si sovrappone ad un orario già inserito.");
      return;
    }
  
    const updatedPreviews = [...shiftPreviews];
  
    if (index !== null) {
      updatedPreviews[index] = previewData;
      // if (index !== insertionIndex && insertionIndex !== -1) {
      //   updatedPreviews.splice(index, 1);
      //   updatedPreviews.splice(insertionIndex, 0, previewData);
      // }
    } else {
      // if (insertionIndex !== -1) {
      //   updatedPreviews.splice(insertionIndex, 0, previewData);
      // } else {
        updatedPreviews.push(previewData);
      //}
    }
  
    setShiftPreviews(updatedPreviews);
    setShowTimeSlot(false);
    setError('');
    setIsSlotAdded(true);
    setIsSaved(true);

    // TODO da sistemare, troppo connesso tra calendario e preview
    if(selectedDay && onShiftAdded) 
      onShiftAdded(previewData, index);
      setCreatingDS(true);
  };


  const handleDeleteShift = (index) => {
    const updatedPreviews = [...shiftPreviews];
    updatedPreviews.splice(index, 1);
    if(onShiftDeleted)
      onShiftDeleted(selectedDay || '', index)
    setShiftPreviews(updatedPreviews);
  };

  const handleHideTimeSlot = () => {
    setShowTimeSlot(false);
    setError('');
  };

  const handleAddNewSlotClick = () => {
    setShowTimeSlot(true);
    setError('');
  };

  const handleSaveCustomShift = async () => {
    if (!shiftName.trim()) {
      setError("Inserisci il nome del turno per effettuare il salvataggio.");
      return;
    }

    if (shiftPreviews.length === 0) {
      setError("Aggiungi almeno un time slot per il turno.");
      return;
    }

    setIsSaving(true); 
    
    try {
      const timeSlots = shiftPreviews.map(preview => ({
        start_at: formatTime(preview.workStartTime),
        end_at: formatTime(preview.workEndTime),
        breaks: preview.breaks.map(pause => ({
          start_at: formatTime(pause.start_at),
          end_at: formatTime(pause.end_at)
        })),
      }));
      
      const newShift = await createWorkingHoursCompound(token, {
        name: shiftName,
        time_slots: timeSlots,
        ou: selectedOu?.id,
      });
      
      if (onShiftAdded) {
        onShiftAdded(newShift);
        setShiftPreviews(prevPreviews => [...prevPreviews, newShift]);
      }
      
      Swal.fire({
        title: "Turno creato con successo!",
        icon: "success",
      });
      resetSelectedOrganizationalUnit();
      setIsSaved(true);
      setShiftName('');

      setError('');
      setShowTimeSlot(true);
      setShiftPreviews([]);
      setIsSlotAdded(false);
  
    } catch (error) {
      console.error('Errore durante la creazione del turno:', error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Errore durante la creazione del turno",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleEditingTimeSlot = (index ) => {
    setShowAddTimeSlotButton(index === null);
    setShowTimeSlot(false);
  };

  return (
    <div>
      {!selectedDay && (
       
          <div className='grid xl:grid-cols-6 grid-cols-1 mx-4 mt-4 items-center'>
            <label htmlFor="parent" className="text-sm font-medium text-gray-700 mr-4 col-span-1 flex items-center required">Inserisci Nome Turno *</label>
            <div className='col-span-3 sm:col-span-2'>
              <input 
                type="text" 
                value={shiftName} 
                onChange={handleShiftNameChange} 
                className="block w-full mt-1 border-gray-100 rounded-md shadow-md focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 placeholder:text-sm placeholder:text-gray-400" 
                placeholder='Inserisci testo' 
              />
            </div>
          </div>
      
      )}

      <PairOrgUnit 
        onSelectOrganizationalUnit={handleSelectOrganizationalUnit} 
        creatingDS={creatingDS} 
        creatingWWH={creatingWWH} 
        selectedOU={selectedOu}
        onResetOrganizationalUnit={resetSelectedOrganizationalUnit}
      />
      <div className='mb-4'>
        <DailyShiftPreviewTable 
          shiftPreviews={shiftPreviews} 
          onShiftPreview={handleShiftPreview} 
          onDeleteShift={handleDeleteShift} 
          onEditingTimeSlot={handleEditingTimeSlot}
          token={token}
          creatingDS={creatingDS}
          creatingWWH={creatingWWH}
        />
      </div>

      {error && (
        <div className="my-2 mx-4 flex justify-center">
          <p className="text-red-500 text-sm">{error}</p>
        </div>
      )}
      {showTimeSlot && (
        <TimeSlot
          onShiftPreview={handleShiftPreview}
          onCancelEdit={handleHideTimeSlot}
          onSaveEdit={handleSaveCustomShift}
        />
      )}
      {!showTimeSlot && showAddTimeSlotButton && (
        <div className="mt-6 mx-4 flex justify-center">
          <button 
            onClick={handleAddNewSlotClick} 
            className="px-4 mb-2 py-2 rounded-md font-semibold text-sm bg-white border border-solid-2 border-gray-200 shadow-md text-gray-700 uppercase hover:bg-indigo-400 hover:text-white focus:ring-indigo-500 focus:border-indigo-500"
          >
            Aggiungi Fascia Oraria
          </button>
        </div>
      )}
      <div className='my-4 mx-4 flex justify-center'>
        {!selectedDay && isSlotAdded && isSaved && shiftPreviews.length > 0 && (
          <button
            onClick={handleSaveCustomShift}
            className={`uppercase font-semibold text-white text-sm px-4 py-2 rounded-md w-52 ${
              isSaving ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:bg-indigo-500'
            }`}
            disabled={isSaving}
          >
            {isSaving ? 'Salvataggio...' : 'Salva Turno'}
          </button>
        )}
      </div>
    </div>
  );
}
